<style lang="scss"></style>

<template>
	<div ref="container" style="overflow: auto;height: 100%;position: relative;display: flex;flex-direction: column;">
		<div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;position: sticky;top: 0;padding: 20px;">
			<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
			<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
				{{ $t('qttpffx') }}
			</p>
		</div>
		<div ref="chartContent" :style="{ height: chartHeight + 'px' }" style="flex:1;display: flex;justify-content: space-between;overflow: auto;">
			<div :style="{ height: chartHeight + 'px' }" style="position: relative;display: flex;justify-content: center;align-items: center;width: 100%;">

				<div id="tpf-qttpffx" style="box-sizing: border-box;width: 100%;" :style="{ height: chartHeight + 'px' }"></div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_die_caster_pentu',
	components: {

	},
	props: {
		datas: {
			type: Object,
			default: () => {
				return {
					severnDayNH: {
						FF240: [],
						UN160A5S: [],
						UN300MGII: []
					},
				}
			}
		}
	},
	watch: {
		datas(newValue, oldValue) {
			if (this.utils.isEqual(newValue, oldValue)) {
				return;
			}
			this.makeChart();
		}
	},
	data() {
		return {
			timmer: null,
			chartHeight: 0,
			chart: null,
			option: null,

		};
	},
	created() {
		this.timmer = setInterval(() => {
		}, 120000)
	},
	mounted() {
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
		this.makeChart();
		this.resize();
	},

	destroyed() {
		clearInterval(this.timmer)
	},
	methods: {
		makeChart() {

			console.log(this.datas);
			if (!this.datas.severnDayNH) {
				return
			}

			let FF240_time = this.datas.severnDayNH.FF240.map(item => { return item.time; });
			let FF240_value = this.datas.severnDayNH.FF240.map(item => { return (item.value * 0.533).toFixed(2); });

			let UN160A5S_time = this.datas.severnDayNH.UN160A5S.map(item => { return item.time; });
			let UN160A5S_value = this.datas.severnDayNH.UN160A5S.map(item => { return (item.value * 0.533).toFixed(2); });

			let UN300MGII_time = this.datas.severnDayNH.UN300MGII.map(item => { return item.time; });
			let UN300MGII_value = this.datas.severnDayNH.UN300MGII.map(item => { return (item.value * 0.533).toFixed(2); });
			if (this.$refs.container) {
				this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 2;

			}
			if (!this.chart) {
				setTimeout(() => {
					this.initChart();
				}, 100);
			}
			setTimeout(() => {

				if (this.option.xAxis.length == undefined) {
					this.option.xAxis.data = FF240_time.map(item => { return this.dayjs(item).format('MM-DD') });
				} else {
					this.option.xAxis[0].data = FF240_time.map(item => { return this.dayjs(item).format('MM-DD') });
				}

				console.log(FF240_time)
				console.log(FF240_value)

				this.option.series[0].data = FF240_value;
				this.option.series[1].data = UN160A5S_value;
				this.option.series[2].data = UN300MGII_value;

				this.chart.setOption(this.option);
			}, 200);


		},
		initChart() {
			this.option = {
				backgroundColor: null,
				tooltip: {
					trigger: "axis",
					axisPointer: {
						// 坐标轴指示器，坐标轴触发有效
						type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
					},
				},
				grid: {
					left: "20",
					right: "20",
					bottom: "10",
					top: "10",
					containLabel: true,
				},

				legend: {
					show: false,

					data: ["FF240", "UN160A5S", "UN300MGII"],
					textStyle: {
						fontSize: 12,
						color: "#FFFFFF",
					},
				},

				xAxis: {
					show: true,
					type: "category",
					axisLabel: {
						textStyle: {
							fontSize: 12,
							color: "#FFFFFF",
						},
						interval: "auto",
					},
					axisTick: {
						show: false,
					},
					data: this.t,
				},
				yAxis: [
					{
						position: 'left',
						show: true,
						type: "value",
						min: 0,

						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								fontSize: 12,
								color: "#FFFFFF",
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: "dashed",
								color: "#606672",
							},
						},
					},
				],
				series: [
					{
						name: "FF240",
						type: "line",
						barWidth: "8px",
						itemStyle: {
							normal: {
								color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#0882FF",
									},
									{
										offset: 1,
										color: "#0882FF",
									},
								]),
								barBorderRadius: 4,
							},
						},
						yAxisIndex: 0,
						data: [],
					},
					{
						name: "UN160A5S",
						type: "line",
						barWidth: "8px",
						symbol: 'none', // 关键修改：隐藏数据点

						itemStyle: {
							normal: {
								color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#E8FF38",
									},
									{
										offset: 1,
										color: "#E8FF38",
									},
								]),
								barBorderRadius: 4,
							},
						},
						yAxisIndex: 0,

						data: [],
					},
					{
						name: "UN300MGII",
						type: "line",
						barWidth: "8px",
						symbol: 'none', // 关键修改：隐藏数据点

						itemStyle: {
							normal: {
								color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#05FB90",
									},
									{
										offset: 1,
										color: "#05FB90",
									},
								]),
								barBorderRadius: 4,
							},
						},

						data: [],
						yAxisIndex: 0,

					},
				],
			};
			var chartDom = document.getElementById("tpf-qttpffx");
			this.chart = this.echarts.init(chartDom);
			this.option && this.chart.setOption(this.option);
		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.chartContent) {
					return;
				}
				this.chartHeight = this.$refs.chartContent.offsetHeight - 20;
				setTimeout(() => {
					if (this.chart != null) {
						this.chart.getDom().style.height = this.chartHeight + "px";
						this.chart.resize();
					}
				}, 0);

			}, 500);
		}
	}
};
</script>
